'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
export { $c_Lcom_raquo_ew_JsArray$RichJsArray$ as $c_Lcom_raquo_ew_JsArray$RichJsArray$ };
$p = $c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_ew_JsArray$RichJsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
export { $h_Lcom_raquo_ew_JsArray$RichJsArray$ as $h_Lcom_raquo_ew_JsArray$RichJsArray$ };
$h_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = $p;
$p.Va = (function(this$, item, fromIndex) {
  return ((this$.indexOf(item, fromIndex) | 0) !== (-1));
});
$p.U2 = (function(this$, cb) {
  var i = 0;
  var len = (this$.length | 0);
  while ((i < len)) {
    cb(this$[i]);
    i = ((1 + i) | 0);
  }
});
var $d_Lcom_raquo_ew_JsArray$RichJsArray$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_ew_JsArray$RichJsArray$, "com.raquo.ew.JsArray$RichJsArray$", ({
  hr: 1
}));
export { $d_Lcom_raquo_ew_JsArray$RichJsArray$ as $d_Lcom_raquo_ew_JsArray$RichJsArray$ };
var $n_Lcom_raquo_ew_JsArray$RichJsArray$;
function $m_Lcom_raquo_ew_JsArray$RichJsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$RichJsArray$)) {
    $n_Lcom_raquo_ew_JsArray$RichJsArray$ = new $c_Lcom_raquo_ew_JsArray$RichJsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$RichJsArray$;
}
export { $m_Lcom_raquo_ew_JsArray$RichJsArray$ as $m_Lcom_raquo_ew_JsArray$RichJsArray$ };
